import React, { useState, useEffect, useRef } from "react";
import css from "../css/gamehis.module.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";
import axios from "axios";
import Invoice from "./Invoice";
import { AiOutlineDownload } from "react-icons/ai";
import "./invoice.css";
import socket from "../Components/socket";

import { BsFillEyeFill } from "react-icons/bs";
import { apiRequest } from "../store/allApi";
import { FaRocketchat } from "react-icons/fa6";
import $ from "jquery";
const Transactionhistory = () => {


  // const [invoiceData, setInvoiceData] = useState("");
  // const [cardData, setGame] = useState();

  // const handleClose = () => setShow(false);
  // const handleShow = (e) => {
  //   setShow(true);
  //   setInvoiceData(e);
  // };

  // const handlePageClick = async (data) => {
  //   let currentPage = data.selected + 1;
  //   setPageNumber(currentPage);
  // };


  // const [Withdrawal, setWithdrawal] = useState();
  // const [showBottom, setShowBottom] = useState(false);

  // const handleCloseBottom = () => setShowBottom(false);
  // const handleShowBottom = (data) => {
  //   setShowBottom(true);
  //   setWithdrawal(data);
  // };



  // BASE URL
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;


  const [activeTab, setActiveTab] = useState("wallet");
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  let printRef = useRef(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const [user, setUser] = useState("");
  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(`me`, "GET", null, headers)
      if (res.data) {
        setUser(res.data);
        fetchData(res?.data?._id, pageNumber, limit);
      }
    } catch (e) {
      // setLoading(false)
    }
  };



  // ALL APIS HERE

  const [walletData, setWalletData] = useState([]);
  const [gameData, setGameData] = useState([]);
  const [penaltyData, setPenaltyData] = useState([]);
  const [bonusData, setBonusData] = useState([]);


  const fetchData = async (id, pageNumber, limit) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    setIsLoading(true);

    try {
      const res = await apiRequest(`temp/deposite/${id}?page=${pageNumber}&_limit=${limit}`, "GET", null, headers);

      if (res) {
        const data = res.data.ress;

        // Filter data based on Req_type
        const walletData = data.filter(item => item.Req_type !== "penalty" && item.Req_type !== "bonus");
        const penaltyData = data.filter(item => item.Req_type === "penalty");
        const bonusData = data.filter(item => item.Req_type === "bonus");

        setWalletData(walletData);
        setPenaltyData(penaltyData);
        setBonusData(bonusData);
        setNumberOfPages(res.data.totalPages);
      }

      // Fetch game data

      const gameRes = await apiRequest(`game/history/user/${id}?page=${pageNumber}&_limit=${limit}`, "GET", null, headers);
      if (gameRes) {
        setGameData(gameRes?.data?.data);
      }

      setIsLoading(false);
    } catch (e) {
      // setLoading(false)
    }
  };


  useEffect(() => {
    role();
  }, [pageNumber, limit]);





  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  return (
    <>
      <div className="leftContainer mb_space">
        <div className="Orher_page_main_section">
          <section className="transaction_main_section_modal">
            <h2 className="profile_headings mt-5 pt-1"></h2>
            <ul className="nav nav-tabs" role="tablist">
              {[
                { id: "wallet", label: "Wallet" },
                { id: "game", label: "Game" },
                { id: "penalty", label: "Penalty" },
                { id: "bonus", label: "Bonus" },
              ].map(({ id, label }) => (
                <li className="nav-item" role="presentation" key={id}>
                  <button
                    className={`nav-link ${activeTab === id ? "active" : ""}`}
                    onClick={() => setActiveTab(id)}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>

            <div className="tab-content">

              {activeTab === "wallet" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {walletData?.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">No Wallet History</h3>
                          <p className="text-muted">
                            You have not made any wallet transactions yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"

                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    walletData?.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Wallet History</h3>
                        <p className="text-muted">
                          You have not made any wallet transactions yet.
                        </p>
                      </div>
                    )
                  )}
                  {walletData?.map((walletData) => (
                    <div className="other_pages_card_main" key={walletData?._id}>
                      <div>
                        <h3>{walletData?.titleMsg}</h3>
                        <h3>
                          Type :{" "}
                          <span className="dark_light_color"> {walletData?.Req_type}</span>
                        </h3>
                        <p>
                          Status:
                          <span className="dark_light_color">
                            {walletData?.status}
                          </span>
                        </p>
                        <p className="dander_text transaction_msg">
                          {walletData?.txn_msg}
                        </p>
                      </div>
                      <div className="transaction_right_side_main">
                        {/* <div className="card_rupee d-flex float-right">
                          <div className="text-danger">(-)</div>
                          <picture className="">
                            <span>₹</span>
                            
                          </picture>
                          <span className="pl-1">{walletData?.amount}</span>
                        </div> */}
                        <div className="card_rupee d-flex float-right">
                          <div
                            className={
                              walletData?.status === "PAID"
                                ? "text-success"
                                : walletData?.status === "SUCCESS"
                                  ? "text-success"
                                  : "text-dark"
                            }

                          >
                            {walletData?.status === "PAID"
                              ? "(+)"
                              : walletData?.status === "SUCCESS"
                                ? "(+)"
                                : "❌"}
                          </div>

                          <picture className="">
                            <span>₹</span>
                          </picture>
                          <span className="pl-1">{walletData?.amount}</span>
                        </div>

                        <div>
                          {walletData?.closing_balance && (
                            <div
                              className={`${css.games_section_headline}`}
                              style={{
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              closing balance :{walletData?.closing_balance}
                            </div>
                          )}
                        </div>
                        <div className="card_date">
                          <p>{dateFormat(walletData?.createdAt).split(",")[0]}</p>
                          <p>{dateFormat(walletData?.createdAt).split(",")[1]}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}


              {activeTab === "penalty" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {penaltyData.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">No Penalty History</h3>
                          <p className="text-muted">
                            You have not made any penalty transactions yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}

                    </div>
                  ) : (
                    penaltyData.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Penalty History</h3>
                        <p className="text-muted">
                          You have not made any penalty transactions yet.
                        </p>
                      </div>
                    )
                  )}
                  {penaltyData.map((card) => (
                    <div className="other_pages_card_main" key={card?._id}>
                      <div>
                        <h3>{card?.titleMsg}</h3>
                        <h3>
                          Type:{" "}
                          <span className="dark_light_color"> {card?.Req_type}</span>

                        </h3>
                        <p>
                          Status:
                          <span className="dark_light_color">
                            {card?.status}
                          </span>
                        </p>
                        <p className="dander_text transaction_msg">
                          {card?.txn_msg}
                        </p>
                      </div>
                      <div className="transaction_right_side_main">
                        <div className="card_rupee d-flex float-right">
                          <div className="text-danger">(-)</div>
                          <picture className="">
                            <span>₹</span>
                          </picture>
                          <span className="pl-1">{card?.amount}</span>
                        </div>
                        <div>
                          {card?.closing_balance && (
                            <div
                              className={`${css.games_section_headline}`}
                              style={{
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              closing balance :{card?.closing_balance}
                            </div>
                          )}
                        </div>
                        <div className="card_date">
                          <p>{dateFormat(card?.createdAt).split(",")[0]}</p>
                          <p>{dateFormat(card?.createdAt).split(",")[1]}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}


              {activeTab === "bonus" && (
                <div className="tab-pane fade show active">
                  {isLoading ? (
                    <div className="text-center">
                      {bonusData.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">No Bonus History</h3>
                          <p className="text-muted">
                            You have not received any bonuses yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    bonusData.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Bonus History</h3>
                        <p className="text-muted">
                          You have not received any bonuses yet.
                        </p>
                      </div>
                    )
                  )}
                  {bonusData.map((card) => (
                    <div className="other_pages_card_main" key={card?._id}>
                      <div>
                        <h3>{card?.titleMsg}</h3>
                        <h3>
                          Type:{" "}
                          <span className="dark_light_color"> {card?.Req_type}</span>
                        </h3>
                        <p>
                          Status:
                          <span className="dark_light_color">
                            {card?.status}
                          </span>
                        </p>
                        <p className="dander_text transaction_msg">
                          {card?.txn_msg}
                        </p>
                      </div>
                      <div className="transaction_right_side_main">
                        <div className="card_rupee d-flex float-right">
                          <div className="text-success">(+)</div>
                          <picture className="">
                            <span>₹</span>
                          </picture>
                          <span className="pl-1">{card?.amount}</span>
                        </div>
                        <div>
                          {card?.closing_balance && (
                            <div
                              className={`${css.games_section_headline}`}
                              style={{
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              closing balance :{card?.closing_balance}
                            </div>
                          )}
                        </div>
                        <div className="card_date">
                          <p>{dateFormat(card?.createdAt).split(",")[0]}</p>
                          <p>{dateFormat(card?.createdAt).split(",")[1]}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}


              {activeTab === "game" && (
                <div className="tab-pane fade show active">

                  {isLoading ? (
                    <div className="text-center">
                      {gameData?.length === 0 ? (
                        <div className="mt-2">
                          <h3 className="font-weight-bold">No Game History</h3>
                          <p className="text-muted">
                            You have no game history yet.
                          </p>
                        </div>
                      ) : (
                        <div
                          className="loaderReturn text-center"
                          style={{ zIndex: "99" }}
                        >
                          <img
                            src={"/images/LandingPage_img/loader1.gif"}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    gameData?.length === 0 && (
                      <div className="mt-3 text-center">
                        <h3 className="font-weight-bold">No Game History</h3>
                        <p className="text-muted">
                          You have no game history yet.
                        </p>
                      </div>
                    )
                  )}
                  {gameData.map((card) => (
                    <div className="other_pages_card_main" key={card?._id}>
                      <div>
                        <p>
                          Status :
                          <span className="ml-2">
                            <b>
                              {card.Status === "completed"
                                ? card?.Winner && card?.Winner?._id === user?._id
                                  ? "Win Against"
                                  : "Lost Against"
                                : card?.Status}
                            </b>
                          </span>
                        </p>
                        <p>
                          Player Name:
                          <span className="dark_light_color">
                            {card?.Accepetd_By?.Name}
                          </span>
                        </p>
                        <p>
                          Game Amount :
                          <span className="dark_light_color">
                            {card?.Game_Ammount}
                          </span>
                        </p>
                        <p>
                          Battle ID :
                          <span className="dark_light_color">
                            {card?._id}
                          </span>
                        </p>
                        {/* <p className="dander_text transaction_msg">
                          {card?.txn_msg}
                        </p> */}
                      </div>
                      <div className="transaction_right_side_main">
                        <div className="card_rupee d-flex float-right">

                          <div class=" gaming_chat_icon_main"><button class="gaming_chat_icon"><FaRocketchat /></button></div>
                          {/* <div className="text-success">(+)</div> */}
                          {/* <picture className="">
                            <span>₹</span>
                          </picture> */}
                          {/* <span className="pl-1">{card?.amount}</span> */}
                        </div>
                        <div>


                          {card.Status != 'cancelled' ? <div
                            className={`${css.games_section_headline}`}
                            style={{
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            closing balance : {card?.Winner?.id === user?._id
                              ? card?.Winner_closingbalance
                              : card?.Loser_closingbalance}
                          </div>
                            :
                            <div
                              className={`${css.games_section_headline}`}
                              style={{
                                fontSize: "12px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              closing balance : {card?.Created_by?.id === user?._id
                                ? card?.Loser_closingbalance
                                : card?.Winner_closingbalance}
                            </div>

                          }
                        </div>
                        <div className="card_date">
                          <p>{dateFormat(card?.createdAt).split(",")[0]}</p>
                          <p>{dateFormat(card?.createdAt).split(",")[1]}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Transactionhistory;